import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { LocationsActions, LocationsState } from '@/stores/locations.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import {
  Location as LocationModel,
  LocationType,
  nameRules,
  locationTypes,
} from '@/models/location.model';
import locationsService from '@/services/locations.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'LocationForm',
  props: {
  data: {
    type: Object as PropType<LocationModel>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { los: LocationsState }>();

const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const location = ref<LocationModel>({
  id: NEW_ID,
  name: '',
  type: LocationType.City,
  lat: 0,
  lng: 0,
  radius: 0,
  parentLocation: undefined,
});

const action = computed<string>(() =>
  location.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveLocation = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (location.value.id === NEW_ID) {
      success = await store.dispatch(
        LocationsActions.AddLocation,
        location.value,
      );
    } else {
      success = await store.dispatch(
        LocationsActions.UpdateLocation,
        location.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved Location',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(LocationsActions.GetLocations);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save Location',
      type: 'error',
    });
  }
};

const updateLanguage = async () => {
  if (location.value.id === NEW_ID) {
    Object.assign(location, { name: '' });
  } else {
    const item = await store.dispatch(
      LocationsActions.GetLocation,
      location.value.id,
    );

    if (item) {
      Object.assign(location.value, {
        ...item,
        startDate: new Date(item.startDate || new Date().toISOString()),
        endDate: new Date(item.endDate || new Date().toISOString()),
      });
    }
  }
};

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);

  if (props.data) {
    Object.assign(location.value, {
      ...props.data,
    });
  }
});

const removeLocation = async () => {
  if (
    location.value &&
    location.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "Location"?')
  ) {
    store.dispatch(LocationsActions.DeleteLocation, location.value.id);

    store.commit(Mutations.HideDrawer);
  }
};

const search = ref<string>('');

const findCoordinates = async () => {
  const result = await locationsService.findCoordinates(search.value);

  if (result.status && result.data.lat !== 0) {
    location.value.lat = result.data.lat;
    location.value.lng = result.data.lng;
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: `No coordinates found for ${search.value}`,
      type: 'warning',
    });
  }
};

const checkCoordinates = () => {
  window.open(
    `http://www.google.com/maps/place/${location.value.lat},${location.value.lng}`,
    '_new',
  );
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveLocation, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a event item ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: location.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((location.value.name) = $event)),
                    rules: _unref(nameRules),
                    label: "Name",
                    required: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    label: "Type",
                    modelValue: location.value.type,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((location.value.type) = $event)),
                    items: _unref(locationTypes)
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: location.value.lat,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((location.value.lat) = $event)),
                    modelModifiers: { number: true },
                    label: "Latitude"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: location.value.lng,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((location.value.lng) = $event)),
                    modelModifiers: { number: true },
                    label: "Longitude"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: checkCoordinates,
                    color: "info"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("Check")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "10" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search).value = $event)),
                    label: "Search for coordinates"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pt-5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    onClick: findCoordinates,
                    color: "info",
                    disabled: !search.value.length
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("Search")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: location.value.radius,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((location.value.radius) = $event)),
                    modelModifiers: { number: true },
                    label: "Radius"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "button",
                    color: "warning",
                    onClick: removeLocation,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("Delete")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})